import groq from 'groq';
import sanityRequest from '@/sanity/requests/base';
// import { getImageAttributes } from '@/sanity';
import { TransformedImage, Work, WorkImage, WorkListing } from '@/types';
import { SanityImageObject } from '@sanity/image-url/lib/types/types';
import { getImageAttributes, getImageAttributesRatio } from '..';
import { watch } from 'vue';
import { RouteLocationNormalizedLoaded } from 'vue-router';

const query = groq`*[ _type == "work" && slug.current == $slug][0] {
  _id,
  title,
  "slug": slug.current,
  available,
  year,
  medium,
  serial,
  price,
  notes,
  description,
  artist->{_id, name},
  dimensions,
  images,
  "works": *[_type == "work" && artist._ref == ^.artist._ref && _id != ^._id] | order(order asc) {
    _id,
    title,
    "slug": slug.current,
    year,
    price,
    artist->{_id, name},
    "thumb": images[0]
  },
}`;

export default function getWork(route: RouteLocationNormalizedLoaded) {
  const { sanity, store, loading, data, setData, setMeta } = sanityRequest<
    Work<WorkImage>
  >();

  const execute = async () => {
    loading.value = true;

    const slug = Array.isArray(route.params.work)
      ? route.params.work[0]
      : route.params.work;

    if (!slug) return;

    const work = store.state.works[slug];
    if (work) {
      setData(work);
      setMeta(work);
    } else {
      const res = await sanity.client.fetch<
        Work<SanityImageObject, SanityImageObject>
      >(query, {
        slug,
      });

      const works = res.works.map((work) => {
        const transformed: WorkListing = {
          ...work,
          thumb: getImageAttributesRatio(work.thumb, 1000, 3 / 4),
          // thumb: getImageAttributes(work.thumb),
        };
        return transformed;
      });

      const work: Work<WorkImage, TransformedImage> = {
        ...res,
        images: res.images.map((image) => ({
          small: getImageAttributes(image),
          large: getImageAttributes(image, 2000),
        })),
        works,
      };
      store.commit.setWork(work);
      setData(store.state.works[slug]);
      setMeta(work);
    }
  };

  execute();
  watch(() => route.params, execute);

  return { data, loading };
}
